/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import {createReactQueryMutationHook} from '../types'
import {verifyCheckAddress} from '../api'

export const useMutationVerifyCheckAddress = createReactQueryMutationHook('verifyCheckAddress', verifyCheckAddress)
